<script setup>
name: 'postsReel'
const props = defineProps({
  posts: {
    type: Object,
    required: true
  },
  meta: {
    type: Object,
    required: true
  },
  nextItem: {
    type: Number,
    required: false
  },
  filters: {
    type: String,
    required: false
  }
})

let nextPost = props.nextItem ? props.nextItem : 1, postsArr = ref([]), totalPosts = ref(props.meta.pagination.total), extraParams = props.filters ? '&' + props.filters : '', loading = ref(false)

addPostsToPage(props.posts)

const { getPosts } = useBlogData()

async function showMorePosts() {
  // If the next posts is less than the total posts in the query we process the request
  if (nextPost < totalPosts.value) {
    // disable the button so it doesn't have multiple clicks at once and do multiple requests
    let showMoreBtn = document.getElementById('show-more-btn')
    showMoreBtn.classList.add('disabled')
    loading.value = true
    // use the params to get extra posts from the next post needed and params (like category) if they were set
    let paramsString = `?sort=publishedAt:DESC&pagination[limit]=6&pagination[start]=${nextPost}&pagination[withCount]=true${extraParams}`
    const { data: postsReel, error: postsError } = await getPosts(paramsString)
    addPostsToPage(postsReel.value.data)
    showMoreBtn.classList.remove('disabled')
    loading.value = false
    nextPost += 6  
  }
}

// Simple function to add posts to page
function addPostsToPage (data) {
  for (let index in data) {
    postsArr.value.push(data[index])
  }
}
</script>

<template>
  <div class="container" id="posts-reel-container">
    <div class="row" id="posts-inner-container">
      <div class="col-12 col-sm-6 col-lg-4 d-flex" v-for="post in postsArr">
        <BlogPostPreview :post="post" />
      </div>
    </div>
  </div>
  <div class="container show-more-container" :class="nextPost < totalPosts ? '' : 'no-show'">
    <div class="row">
      <div class="col-12 text-center">
        <button @click="showMorePosts" class="btn btn-secondary more-posts-btn" id="show-more-btn">Show more</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
#posts-reel-container{
  transition: 0.5s ease-in-out;
  overflow: hidden;
}
.show-more-container{
  transition: 0.5s ease-in-out;
  height: 100px;
  visibility: visible;
  opacity: 1;
  margin-top: 40px;
  &.no-show{
    height: 0;
    visibility: hidden;
    opacity: 0;
  }
  .loading {
    margin-top: 10px;
    .icon{
      display: block;
      background: red;
      width: 40px;
      height: 40px;
    }
  }
}
.btn{
  &.more-posts-btn{
    width: 100%;
    padding-top: 16px;
    padding-bottom: 16px;
  }
}
@include media-breakpoint-up(lg){
  .btn{
    &.more-posts-btn{
      width: auto;
      min-width: 390px;
    }
  }
}
</style>